import { useSelector } from "react-redux";
import networkSelectors from "../selectors/network";

export default function useNetworkHeaders() {
  return useSelector(networkSelectors.defaultHeaders);
}
